import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import openai from '../../../services/openaiClient';

const PaymentReminderActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('pending');
  const [aiQuery, setAiQuery] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [isLoadingAI, setIsLoadingAI] = useState(false);
  const [reminderFrequency, setReminderFrequency] = useState('daily');
  const [autoReminder, setAutoReminder] = useState(true);

  const handleAIPaymentStrategy = async () => {
    setIsLoadingAI(true);
    try {
      const completion = await openai?.chat?.completions?.create({
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'أنت مساعد ذكي متخصص في إدارة المدفوعات والتذكيرات المالية. قدم استراتيجيات فعالة لتحصيل المدفوعات.'
          },
          {
            role: 'user',
            content: aiQuery || 'ما هي أفضل طريقة لتذكير العملاء بالمدفوعات المتأخرة؟'
          }
        ],
        temperature: 0.7,
        max_tokens: 500
      });
      
      setAiResponse(completion?.choices?.[0]?.message?.content || 'لم يتم الحصول على رد');
    } catch (error) {
      console.error('AI Analysis Error:', error);
      setAiResponse('حدث خطأ في تحليل الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoadingAI(false);
    }
  };

  const handleSendReminder = (paymentId) => {
    console.log('Sending reminder for payment:', paymentId);
    alert('تم إرسال التذكير بنجاح');
  };

  const handleSaveReminderSettings = () => {
    console.log('Saving reminder settings:', { reminderFrequency, autoReminder });
    alert('تم حفظ إعدادات التذكير بنجاح');
  };

  const tabs = [
    { id: 'pending', label: 'المدفوعات المعلقة', icon: 'Clock' },
    { id: 'ai-strategy', label: 'استراتيجية التحصيل', icon: 'Brain' },
    { id: 'settings', label: 'إعدادات التذكير', icon: 'Settings' }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="تذكير الدفع"
      icon="DollarSign"
      iconColor="#8B5CF6"
      size="xl"
      footer={null}
    >
      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-border">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'pending' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">المدفوعات المعلقة والمتأخرة</h3>
            
            <div className="space-y-3">
              <div className="p-4 border-l-4 border-red-500 bg-red-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-red-900">PAY-2026-045</h4>
                    <p className="text-sm text-red-700">أحمد محمد السعيد - عقد CNT-2026-001</p>
                  </div>
                  <div className="text-left">
                    <p className="text-lg font-bold text-red-600">15,000 ريال</p>
                    <span className="px-2 py-1 bg-red-200 text-red-800 text-xs rounded font-semibold">متأخر 5 أيام</span>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-red-700 mb-2">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    الاستحقاق: ٢٠٢٦/٠١/٠٥
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" onClick={() => handleSendReminder('PAY-2026-045')}>
                    <span className="flex items-center gap-1">
                      <Icon name="Send" size={14} />
                      إرسال تذكير
                    </span>
                  </Button>
                  <Button size="sm" variant="outline">
                    <span className="flex items-center gap-1">
                      <Icon name="Phone" size={14} />
                      اتصال
                    </span>
                  </Button>
                </div>
              </div>

              <div className="p-4 border-l-4 border-orange-500 bg-orange-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-orange-900">PAY-2026-052</h4>
                    <p className="text-sm text-orange-700">فاطمة خالد - عقد CNT-2026-008</p>
                  </div>
                  <div className="text-left">
                    <p className="text-lg font-bold text-orange-600">8,500 ريال</p>
                    <span className="px-2 py-1 bg-orange-200 text-orange-800 text-xs rounded font-semibold">يستحق اليوم</span>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-orange-700 mb-2">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    الاستحقاق: ٢٠٢٦/٠١/١٠
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" onClick={() => handleSendReminder('PAY-2026-052')}>
                    <span className="flex items-center gap-1">
                      <Icon name="Send" size={14} />
                      إرسال تذكير
                    </span>
                  </Button>
                </div>
              </div>

              <div className="p-4 border-l-4 border-yellow-500 bg-yellow-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-yellow-900">PAY-2026-061</h4>
                    <p className="text-sm text-yellow-700">محمد عبدالله - عقد CNT-2026-012</p>
                  </div>
                  <div className="text-left">
                    <p className="text-lg font-bold text-yellow-600">12,000 ريال</p>
                    <span className="px-2 py-1 bg-yellow-200 text-yellow-800 text-xs rounded font-semibold">خلال 3 أيام</span>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-yellow-700">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    الاستحقاق: ٢٠٢٦/٠١/١٣
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-6">
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-red-600">12</p>
                <p className="text-xs text-red-700">متأخر</p>
                <p className="text-sm font-semibold text-red-600 mt-1">85,000 ريال</p>
              </div>
              <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-orange-600">8</p>
                <p className="text-xs text-orange-700">يستحق اليوم</p>
                <p className="text-sm font-semibold text-orange-600 mt-1">52,000 ريال</p>
              </div>
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-yellow-600">25</p>
                <p className="text-xs text-yellow-700">قادم</p>
                <p className="text-sm font-semibold text-yellow-600 mt-1">180,000 ريال</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'ai-strategy' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">استراتيجية التحصيل الذكية</h3>
            
            <div className="space-y-3">
              <label className="block text-sm font-medium">اسأل عن استراتيجية التحصيل</label>
              <Input
                value={aiQuery}
                onChange={(e) => setAiQuery(e?.target?.value)}
                placeholder="مثال: كيف أتعامل مع عميل متأخر في الدفع لأكثر من أسبوع؟"
                className="w-full"
              />
              <Button
                onClick={handleAIPaymentStrategy}
                disabled={isLoadingAI}
                className="w-full"
              >
                {isLoadingAI ? (
                  <span className="flex items-center gap-2">
                    <Icon name="Loader" size={18} className="animate-spin" />
                    جاري التحليل...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Icon name="Brain" size={18} />
                    احصل على استراتيجية
                  </span>
                )}
              </Button>
            </div>

            {aiResponse && (
              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start gap-2 mb-2">
                  <Icon name="Lightbulb" size={20} className="text-blue-600 mt-1" />
                  <h4 className="font-semibold text-blue-900">توصيات الذكاء الاصطناعي</h4>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{aiResponse}</p>
              </div>
            )}

            <div className="mt-6 p-4 bg-muted/30 rounded-lg">
              <h4 className="font-semibold mb-3 flex items-center gap-2">
                <Icon name="TrendingUp" size={18} className="text-green-600" />
                أفضل ممارسات التحصيل
              </h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>إرسال تذكير ودي قبل 3 أيام من الاستحقاق</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>اتصال هاتفي للمدفوعات المتأخرة أكثر من 3 أيام</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>تقديم خيارات دفع مرنة للعملاء</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>توثيق جميع محاولات التواصل</span>
                </li>
              </ul>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="p-4 border border-border rounded-lg">
                <Icon name="MessageSquare" size={24} className="text-blue-600 mb-2" />
                <h4 className="font-semibold mb-1">تذكير ودي</h4>
                <p className="text-sm text-muted-foreground">قبل الاستحقاق بـ 3 أيام</p>
              </div>
              
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Phone" size={24} className="text-orange-600 mb-2" />
                <h4 className="font-semibold mb-1">اتصال مباشر</h4>
                <p className="text-sm text-muted-foreground">للمدفوعات المتأخرة</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">إعدادات التذكير التلقائي</h3>
            
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="auto-reminder"
                  checked={autoReminder}
                  onChange={(e) => setAutoReminder(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <label htmlFor="auto-reminder" className="flex-1">
                  <span className="font-medium">تفعيل التذكير التلقائي</span>
                  <p className="text-sm text-muted-foreground">إرسال تذكيرات تلقائية للمدفوعات المستحقة</p>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">تكرار التذكير</label>
                <select
                  value={reminderFrequency}
                  onChange={(e) => setReminderFrequency(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="daily">يومياً</option>
                  <option value="every-2-days">كل يومين</option>
                  <option value="every-3-days">كل 3 أيام</option>
                  <option value="weekly">أسبوعياً</option>
                </select>
              </div>

              <div className="p-4 bg-muted/30 rounded-lg">
                <h4 className="font-semibold mb-3">جدول التذكيرات</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center justify-between p-2 bg-background rounded">
                    <span>قبل الاستحقاق بـ 3 أيام</span>
                    <span className="text-blue-600 font-medium">تذكير ودي</span>
                  </div>
                  <div className="flex items-center justify-between p-2 bg-background rounded">
                    <span>يوم الاستحقاق</span>
                    <span className="text-orange-600 font-medium">تذكير رسمي</span>
                  </div>
                  <div className="flex items-center justify-between p-2 bg-background rounded">
                    <span>بعد التأخير بـ 3 أيام</span>
                    <span className="text-red-600 font-medium">اتصال مباشر</span>
                  </div>
                  <div className="flex items-center justify-between p-2 bg-background rounded">
                    <span>بعد التأخير بـ 7 أيام</span>
                    <span className="text-red-700 font-medium">تصعيد للإدارة</span>
                  </div>
                </div>
              </div>

              <div className="p-4 bg-muted/30 rounded-lg">
                <h4 className="font-semibold mb-3">قنوات التذكير</h4>
                <div className="space-y-2">
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <Icon name="Mail" size={16} />
                    <span className="text-sm">البريد الإلكتروني</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <Icon name="MessageSquare" size={16} />
                    <span className="text-sm">رسالة نصية SMS</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" className="w-4 h-4" />
                    <Icon name="Phone" size={16} />
                    <span className="text-sm">مكالمة هاتفية آلية</span>
                  </label>
                </div>
              </div>

              <Button
                onClick={handleSaveReminderSettings}
                className="w-full"
                variant="primary"
              >
                <span className="flex items-center gap-2">
                  <Icon name="Save" size={18} />
                  حفظ الإعدادات
                </span>
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PaymentReminderActionsModal;